module.exports = __webpack_public_path__ + "img/login_background.png";